import { Link } from 'react-router-dom';
import { articles } from '@/mocks/seo-content';

export default function ArticlePreview() {
  const featuredArticle = articles[0];
  const firstSection = featuredArticle.sections[0];

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            Featured Guide
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {featuredArticle.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Everything you need to know about using a Sugargoo Spreadsheet to find better products, save time, and shop smarter.
          </p>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
          <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-4">
            {firstSection.heading}
          </h3>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 line-clamp-4">
            {firstSection.content.split('\n\n')[0]}
          </p>

          <div className="flex flex-wrap gap-3 mb-6">
            {['Shoes Guide', 'QC Photos', 'Shipping Tips', 'Product Finds', 'Category Navigation'].map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="flex items-center justify-between flex-wrap gap-3">
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              Published: {featuredArticle.datePublished} &bull; {featuredArticle.sections.length} sections &bull; 2000+ words
            </span>
            <Link
              to={`/article/${featuredArticle.slug}`}
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}